import React, { useEffect, useState } from 'react';
import './nfdTradeBotsStartSection.scss';
import { ReactComponent as MainLinesImage } from "./components/MainLinesImage.svg";
import { ReactComponent as MainLinesImageAdaptive } from "./components/MainLinesImageAdaptive.svg";
import { ReactComponent as MascotBaseBotAdaptive } from "./icons/MascotBaseBotAdaptive.svg";
import { ReactComponent as MascotTronDaoBotAdaptive } from "./icons/MascotTronDaoBotAdaptive.svg";
import { ReactComponent as SixChainsIcon } from "./icons/SixChainsIcon.svg";
import { ReactComponent as SixChainsIconAdaptive } from "./icons/SixChainsIconAdaptive.svg";

const NfdTradeBotsStartSection = () => {
	const [width, setWidth] = useState(window.innerWidth);
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);

	const clickTradingNow = () => {
		document.getElementById('startTradingNow')?.scrollIntoView({
			behavior: 'smooth'
		});
	};

	return (
		<div className="nfdTradeBotsStart">
			<div className="nfdTradeBotsStart__content">
				{
					width > 767 ? (
						<div className="nfdTradeBotsStart__content_lines">
							<MainLinesImage />
						</div>
					) : (
						<div className="nfdTradeBotsStart__content_lines">
							<MascotBaseBotAdaptive />
							<MainLinesImageAdaptive />
							<MascotTronDaoBotAdaptive />
						</div>
					)
				}
				<div className="nfdTradeBotsStart__content_data">
					{
						width > 767 ? (
							<SixChainsIcon />
						) : (
							<SixChainsIconAdaptive />
						)
					}
					<div className="nfdTradeBotsStart__content_data_title">
						<h1>NFD{width > 767 ? ' ' : <br/>}Trade Bots</h1>
						<span>Trade as quickly and conveniently as possible with all the advanced features of NFD Trade Bots.  All the necessary functionality within one interface.</span>
					</div>
					{
						width > 767 && (
							<div className="nfdTradeBotsStart__content_data_button">
								<button
									className="secondButton"
									onClick={clickTradingNow}
								>
									<span>Trading now</span>
								</button>
							</div>
						)
					}
				</div>
				{
					width < 768 && (
						<div className="nfdTradeBotsStart__content_button">
							<button
								className="secondButton"
								onClick={() => {}}
							>
								<span>Trading now</span>
							</button>
						</div>
					)
				}
			</div>
		</div>
	);
};

export default NfdTradeBotsStartSection;